// components/WhyChooseUs.tsx
import React from 'react';
import {FaCogs, FaGem, FaHandsHelping, FaLightbulb, FaRegSmile} from 'react-icons/fa';
import {useLanguage} from '../contexts/LanguageContext';

interface ReasonType {
    icon: React.ReactNode;
    title: string;
    subtitle: string;
    description: string;
    number: string;
}

interface ContentType {
    sectionTitle: string;
    reasons: ReasonType[];
}

const content: Record<string, ContentType> = {
    en: {
        sectionTitle: "Why Choose RunTop",
        reasons: [
            {
                icon: <FaLightbulb className="text-4xl text-orange-500"/>,
                title: "Creative Design",
                subtitle: "Innovative Solutions",
                description: "Professional design team with years of international exhibition experience, creating unique and effective booth designs.",
                number: "01"
            },
            {
                icon: <FaGem className="text-4xl text-orange-500"/>,
                title: "Premium Quality",
                subtitle: "Superior Standards",
                description: "Expert construction team ensuring structural safety, material selection, and AV equipment integration with years of experience.",
                number: "02"
            },
            {
                icon: <FaCogs className="text-4xl text-orange-500"/>,
                title: "Attention to Detail",
                subtitle: "Precise Execution",
                description: "Meticulous attention to every aspect from materials to lighting, ensuring perfect execution of your exhibition space.",
                number: "03"
            },
            {
                icon: <FaRegSmile className="text-4xl text-orange-500"/>,
                title: "Client Experience",
                subtitle: "Satisfaction Guaranteed",
                description: "Dedicated to providing exceptional client service and ensuring a smooth exhibition experience from start to finish.",
                number: "04"
            },
            {
                icon: <FaHandsHelping className="text-4xl text-orange-500"/>,
                title: "Full Support",
                subtitle: "Comprehensive Service",
                description: "Complete exhibition support including design, construction, logistics, and on-site assistance.",
                number: "05"
            }
        ]
    },
    zh: {
        sectionTitle: "选择RunTop的五大理由",
        reasons: [
            {
                icon: <FaLightbulb className="text-4xl text-orange-500"/>,
                title: "创新设计",
                subtitle: "专业创意",
                description: "拥有多年国际展览经验的专业设计团队，为您打造独特而有效的展台设计方案。",
                number: "01"
            },
            {
                icon: <FaGem className="text-4xl text-orange-500"/>,
                title: "卓越品质",
                subtitle: "品质保证",
                description: "专业施工团队，确保结构安全、材料精选、设备集成，多年经验保障高品质执行。",
                number: "02"
            },
            {
                icon: <FaCogs className="text-4xl text-orange-500"/>,
                title: "精益求精",
                subtitle: "细节完美",
                description: "从材料选择到灯光设计，每个细节都精心打造，确保展台完美呈现。",
                number: "03"
            },
            {
                icon: <FaRegSmile className="text-4xl text-orange-500"/>,
                title: "优质体验",
                subtitle: "客户至上",
                description: "致力于提供卓越的客户服务，确保从开始到结束的展会体验都完美无忧。",
                number: "04"
            },
            {
                icon: <FaHandsHelping className="text-4xl text-orange-500"/>,
                title: "全程服务",
                subtitle: "一站式支持",
                description: "提供设计、搭建、物流到现场支持的全方位展会服务支持。",
                number: "05"
            }
        ]
    }
};

const WhyChooseUs: React.FC = () => {
    const {currentLang} = useLanguage();
    const t = content[currentLang];

    return (
        <div className="py-20">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-16">{t.sectionTitle}</h2>
                <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
                    {t.reasons.map((reason, index) => (
                        <div key={index}
                             className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
                            <div className="flex items-center justify-between mb-4">
                                {reason.icon}
                                <span className="text-gray-300 text-2xl font-bold">{reason.number}</span>
                            </div>
                            <h3 className="text-xl font-bold mb-2">{reason.title}</h3>
                            <p className="text-gray-500 text-sm mb-2">{reason.subtitle}</p>
                            <p className="text-gray-600 text-sm">{reason.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WhyChooseUs;
